import { Table } from 'antd';

const TopProductInCartDesktop = ({ viewModel }) => {
  const { columns, dataSource } = viewModel;

  return <Table columns={columns} dataSource={dataSource} rowKey={(record) => record?.id || record?.product?.id} />;
};

export default TopProductInCartDesktop;
